'use client';

import { createContext, useContext } from 'react';
import type { DeviceState } from '@/app/cc/_types/types';

const DeviceContext = createContext<DeviceState | null>(null);

export function DeviceProvider({
  deviceInfo,
  children,
}: Readonly<{
  deviceInfo: DeviceState;
  children: React.ReactNode;
}>) {
  return <DeviceContext.Provider value={deviceInfo}>{children}</DeviceContext.Provider>;
}

export function useDeviceInfo() {
  const deviceInfo = useContext(DeviceContext);

  if (deviceInfo === null) {
    throw new Error('useDeviceInfo must be used within DeviceProvider');
  }

  return deviceInfo;
}
